export default "__VITE_ASSET__D16XzxpL__"